var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconEditorTextBackground = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { x: "0px", y: "0px", viewBox: "0 0 30 30" },
            React.createElement("path", { fill: color, d: "M12.2,17h5.9l-2.9-7.8L12.2,17z M26.4,0.9H3.7c-1.6,0-2.9,1.3-2.9,2.9v22.6\n\tc0,1.6,1.3,2.9,2.9,2.9h22.6c1.6,0,2.9-1.3,2.9-2.9V3.6C29.1,2,28,0.9,26.4,0.9L26.4,0.9z M20.7,24.1L19,19.9h-8l-1.6,4.2H6.6\n\tl7.2-18.3h2.6l7.2,18.3H20.7L20.7,24.1z" }))));
});
export default IconEditorTextBackground;
//# sourceMappingURL=IconEditorTextBackground.js.map